module.exports = __webpack_public_path__ + "44e670efc467ba6a1e123ca2d622a302.svg";